import { Link } from '@anytag/router';
import { TextCutter } from '@anytag/shared-atoms';
import { InstagramCompareAccount } from '@anytag/graphql';
import { InfluencerAvatar } from '@anytag/shared-molecules';
import { ProfilePostsTabs, ProfilePostsTabType } from '@anytag/shared-organisms';
import { AnalyticsInstagramPostsTemplate } from '../analytics-instagram-posts';
import { AnalyticsIgFeedPostsListSearchSchemaType } from '../schema-types';
import { AnalyticsInstagramComparePostsTemplate } from './analytics-instagram-compare-posts-template';
import { useAnalyticsIgComparePostsFilter } from './hooks';

export interface TemplateProps {
  mainSocialAccountId: number;
  comparableAccounts: InstagramCompareAccount[];
}

export const Template = ({ comparableAccounts, mainSocialAccountId }: TemplateProps) => {
  const { filter } = useAnalyticsIgComparePostsFilter();

  const isMainAccount = mainSocialAccountId === filter.accountId;
  const tabOptions = comparableAccounts.map<ProfilePostsTabType>(({ id, username, avatar }) => ({
    value: id,
    label: (props) => (
      <Link
        key={id}
        to="/analytics/$brandAccountId/$socialMedia/$socialMediaAccountId/compare/instagram_compare_feed_post"
        activeOptions={{ exact: true, includeSearch: true }}
        search={(curr: AnalyticsIgFeedPostsListSearchSchemaType) => ({
          ...curr,
          filter: {
            ...curr.filter,
            accountId: id
          }
        })}
        {...props}
      >
        <InfluencerAvatar size="32px" css={{ marginRight: '4px', borderRadius: '50%' }} src={avatar} asChild />
        <TextCutter text={username} />
      </Link>
    )
  }));

  return filter.accountId ? (
    <>
      <ProfilePostsTabs options={tabOptions} />

      {isMainAccount ? (
        <AnalyticsInstagramPostsTemplate mainSocialAccountId={filter.accountId} isComparePage />
      ) : (
        <AnalyticsInstagramComparePostsTemplate socialAccountId={filter.accountId} />
      )}
    </>
  ) : null;
};
